<div class="container">
  <h2 mat-dialog-title>Add Category</h2>

  <mat-select [formControl]="categoryNames" multiple>
    <mat-option *ngFor="let cat of exerciseCategories" [value]="cat">{{cat.name}}</mat-option>
  </mat-select>

  <mat-dialog-actions>
    <div fxFlex class="buttons" fxLayout="row" fxLayoutAlign="center end" fxLayoutGap="8px">
      <button mat-raised-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="categoryNames.value"
        [disabled]="!categoryNames.valid">Add</button>
    </div>
  </mat-dialog-actions>
</div>